import { createContext, useContext } from 'react';
export const AutocompleteContext = createContext(undefined);
export const useAutocomplete = () => {
    const context = useContext(AutocompleteContext);
    if (context === undefined) {
        throw new Error('useAutocomplete must be used within a AutocompleteProvider');
    }
    return context;
};
//# sourceMappingURL=AutocompleteContext.js.map